import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { required } from "utils/validations";
import { CustomCheckbox } from '../../../../../components/Controls';
import URLS from 'utils/import_urls';

const selector = formValueSelector('kafene_agreement_form');

class Form extends PureComponent {
  componentDidMount() {
    this.checkInitialValidity();
  }

  checkInitialValidity = () => {
    const { additionalData, onDataChange } = this.props;
    const valid = !!additionalData.isTermsChecked && !!additionalData.isReportingChecked;
    onDataChange({
      data: additionalData,
      valid: valid,
    });
  };

  handleChange = () => {
    const { additionalData, onDataChange, valid } = this.props || {};
    onDataChange({
      data: additionalData,
      valid: valid,
    });
  };

  renderCheckbox = ({ input, meta }) => {
    return (
      <CustomCheckbox className="checkbox" meta={meta} {...input} customChange={this.handleChange} />
    );
  };

  render() {
    return (
      <div className="kafene agreement-form-checkbox-container">
        <div className="flex flex__align--baseline agreement-form-checkbox">
          <Field
            name="isTermsChecked"
            validate={[required]}
            component={this.renderCheckbox}
          />
          <div>
            By checking this box you confirm that you have read and agree to Kafene's&nbsp;
            <a href={URLS.TERMS_AND_CONDITIONS_KAFENE} className="link" target="_blank">
              Terms and Conditions
            </a>
            ,&nbsp;
            <a href={URLS.ARBITRATION_AGREEMENT_KAFENE} className="link" target="_blank">
              Arbitration Agreement
            </a>
            , which includes an agreement to arbitrate and waiver of jury trial,&nbsp;
            <a href={URLS.PRIVACY_POLICY_KAFENE} className="link" target="_blank">
              Privacy Policy
            </a>
            ,&nbsp;
            <a href={URLS.GLBA_PRIVACY_NOTICE_KAFENE} className="link" target="_blank">
              GLBA Privacy Notice
            </a>
            ,&nbsp;
            <a href={URLS.DISCLOSURE_AND_CONSENT_KAFENE} className="link" target="_blank">
              E-Sign Disclosure and Consent
            </a>
            &nbsp;and&nbsp;
            <a href={URLS.PROHIBITED_CONDUCT_KAFENE} className="link" target="_blank">
              Prohibited Conduct
            </a>
            .
          </div>
        </div>
        <div className="flex flex__align--baseline agreement-form-checkbox">
          <Field name="isReportingChecked" validate={[required]} component={this.renderCheckbox}/>
          <div>
            By checking this box, you authorize Kafene, Inc., its agents and/or its affiliates ("Kafene") to obtain
            reports about you from consumer reporting agencies. You agree that Kafene may use your consumer reports for
            any lawful purpose, such as: (1) authenticating your identity; (2) making eligibility decisions on rental
            purchase agreements; (3) assisting with internal modeling and analysis; (4) servicing your account during
            the entire life of the agreement with Kafene; and (5) verifying information in your application. Reviewing
            your consumer report for this application will not negatively impact your score.
          </div>
        </div>
        <div className="flex flex__align--baseline agreement-form-checkbox">
          <Field name="isMarketingChecked" component={this.renderCheckbox}/>
          <div>
            <strong>Consent</strong>: By checking this box, you agree that Kafene, Inc., its agents, and its affiliates and the merchant partner where you are shopping may place telemarketing calls, send SMS and text messages, iMessages, and make any other promotional or marketing-related communications to you using an automatic telephone dialing system to the telephone number provided on this application and any other telephone number you provide Kafene. You understand that you do not have to check the box to obtain any good or service from Kafene, Inc. and you certify that you are authorized to provide consent. Msg & data rates may apply.
            Please see our&nbsp;
            <a href={URLS.TERMS_AND_CONDITIONS_KAFENE} className="link" target="_blank">
              Terms and Conditions
            </a>
            .
          </div>
        </div>
      </div>
    );
  }
}

Form.propTypes = {
  onDataChange: PropTypes.func,
};

Form.defaultProps = {
  onDataChange: () => {
  },
};

Form = reduxForm({
  form: 'kafene_agreement_form',
  initialValues: {isTermsChecked: false, isReportingChecked: false, isMarketingChecked:false},
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(Form);

Form = connect((state) => ({
  additionalData: selector(state, 'isTermsChecked', 'isReportingChecked', 'isMarketingChecked'),
}))(Form);

export default Form;
